<mat-card
  *ngIf="pos && pbo"
  [ngClass]="
    isPreliminary(pos) ? 'ai-preliminary' : changed ? 'order-changed' : ''
  ">
  <mat-card-content>
    <div class="ps-grid-3-col">
      <div>
        <h2 class="mat-h2">
          <img class="mat-icon" src="{{ pos.ICON_URL }}"/>
          {{ pos.NAME }}
        </h2>
        <div>
          {{ pos.SNR }}
        </div>
        <div>Projekt: {{ pos.PROJEKT_NAME }} {{ pos.PROJEKT_DESCRIPTION }}</div>
        <div>
          Teilenummer: {{ pos.EXT_SUPPLIER_ID }}
          <button
            mat-button
            color="primary"
            (click)="editCommissionPart(pos.OBJECT_ID)">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <div *ngIf="pos.INDEX_AI">
          AI: {{
            pos.INDEX_AI
          }}<span
          style="color: red; font-weight: bold"
          *ngIf="isPreliminary(pos)">
            ({{ 'orders.positions.tl.preliminary' | translate }} !)</span
        >
        </div>
        <div *ngIf="!pos.INDEX_AI" style="font-weight: bold; color: red">
          {{ 'orders.positions.tl.noAi' | translate }}!
        </div>
      </div>
      <div>
        <mat-icon>schedule</mat-icon>
        {{ pos.TERMINA | date }}
      </div>
      <div class="booking-tag" *ngIf="pos.IS_OMITTED">
        {{ 'orders.positions.omitted' | translate }}
      </div>
      <div *ngIf="!pos.IS_OMITTED">
        <div>
          <mat-icon>functions</mat-icon>
          {{ pos.STUELICOUNT - pos.CALC_OPEN }} / {{ pos.STUELICOUNT }}
        </div>
        <div *ngIf="pos.CALC_OPEN <= 0">
          <mat-icon>check</mat-icon>
          {{ 'orders.positions.tl.fulfilled' | translate }}
        </div>
        <div *ngIf="pos.CALC_OPEN > 0">
          <mat-icon>chevron_right</mat-icon>
          {{ pos.CALC_OPEN }} {{ 'orders.positions.tl.open' | translate }}
        </div>
      </div>
    </div>
    <div class="ps-flex-container-col">
      <div style="justify-self: end; align-self: end">
        <div *ngIf="pos.HAS_MEASUREMENT_PROTOCOL" style="color: #2e7d32">
          <mat-icon>check_circle</mat-icon>
          {{ 'orders.positions.tl.measurementProtocol' | translate }}
        </div>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <button
      mat-button
      *ngIf="isExternal() && !isBm() && !pos.IS_OMITTED"
      color="primary"
      matTooltip="geplante Lieferungen"
      routerLink="/orders/{{ pbo.OBJECT_ID }}/{{
        pos.OBJECT_ID
      }}/planneddeliveries">
      <mat-icon>local_shipping</mat-icon>
    </button>
    <span>|</span>
    <button
      mat-button
      *ngIf="pos.INDEX_AI && isExternal() && !isBm()"
      color="primary"
      (click)="printLabel(pos)"
      matTooltip="{{ 'orders.positions.tl.printLabel' | translate }}">
      <mat-icon>print</mat-icon>
    </button>
    <button
      mat-button
      color="primary"
      matTooltip="{{ 'orders.positions.tl.etaDocuments' | translate }}"
      routerLink="/orders/{{ pbo.OBJECT_ID }}/{{ pos.OBJECT_ID }}/etadocuments">
      <mat-icon>picture_as_pdf</mat-icon>
    </button>
    <span
      *ngIf="
        suppliersService.hasPseChangeDocument(pos) ||
        (isExternal() && !pos.IS_OMITTED)
      "
    >|</span
    >
    <button
      *ngIf="suppliersService.hasPseChangeDocument(pos)"
      mat-button
      color="primary"
      matTooltip="{{ 'orders.positions.tl.changeRemark' | translate }}"
      (click)="openChangedDialog()">
      <mat-icon>task_alt</mat-icon>
    </button>
    <button
      *ngIf="isExternal() && !pos.IS_OMITTED"
      mat-button
      color="primary"
      matTooltip="{{ 'orders.positions.tl.incidents' | translate }}"
      routerLink="/orders/{{ pbo.OBJECT_ID }}/{{ pos.OBJECT_ID }}/incidents">
      <mat-icon>report_problem</mat-icon>
    </button>
    <span>|</span>
    <button
      mat-button
      matTooltip="{{'orders.positions.tl.uploadProtocol' | translate}}"
      color="primary" (click)="uploadMeasurementProtocol()">
      <mat-icon>upload</mat-icon>
    </button>
  </mat-card-actions>
</mat-card>
